import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const LABEL = { name: "Contact name", email: "Email", company_number: "Company number" };

export function XeroChangesTab({ onChange }) {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/client-master/xero-changes").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  async function dismiss(id) {
    try { await api.post(`/client-master/xero-changes/${id}/dismiss`); toast.success("Dismissed"); load(); onChange(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  }

  if (!rows) return <div className="text-sm text-[var(--ink-2)]">Loading…</div>;
  return (
    <div data-testid="xero-changes-tab">
      <div className="text-xs text-[var(--ink-2)] mb-3">Practice-OS is the master. These client details were changed in Xero; Practice-OS has not been updated. Review and dismiss once handled.</div>
      {!rows.length ? <div className="card-flat p-8 text-center text-sm text-[var(--ink-2)]" data-testid="xero-changes-empty">No Xero-side changes to review.</div> : (
        <table className="tbl tbl-ultra" data-testid="xero-changes-table">
          <thead><tr><th>Detected</th><th>Client ID</th><th>Client</th><th>Field</th><th>Was (Xero)</th><th>Now (Xero)</th><th /></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r._id} data-testid={`xc-row-${r._id}`}>
                <td className="text-xs font-mono-data">{(r.detected_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="text-xs font-mono-data">{r.client_uid || "—"}</td>
                <td>{r.client_name}</td>
                <td className="text-xs">{LABEL[r.field] || r.field}</td>
                <td className="text-xs text-[var(--ink-2)]">{r.old || "—"}</td>
                <td className="text-xs font-medium">{r.new || "—"}</td>
                <td className="text-right"><button data-testid={`xc-dismiss-${r._id}`} onClick={() => dismiss(r._id)} className="btn-ghost text-[11px] !py-0.5 !px-2">Dismiss</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
